/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Ukončiť úpravy',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Upraviť',
  'editor-common-extensibility.macro.button.configure': 'Konfigurovať {macroName}',
  'fablric.editor.viewAllInserts': 'Zobraziť všetky vložené položky',
  'fabric.editor.action': 'Položka činnosti',
  'fabric.editor.action.description': 'Vytvoriť a prideliť položky činností',
  'fabric.editor.addAltText': 'Alternatívny text',
  'fabric.editor.addColumnLeft': 'Pridať stĺpec vľavo',
  'fabric.editor.addColumnRight': 'Pridať stĺpec vpravo',
  'fabric.editor.addCommentOnMedia': 'Pridať komentár',
  'fabric.editor.addImageBorder': 'Pridať ohraničenie',
  'fabric.editor.addLoomVideo': 'Nahrať video Loom',
  'fabric.editor.addLoomVideoComment': 'Nahrať videokomentár cez Loom',
  'fabric.editor.addMediaFiles': 'Pridať obrázok, video alebo súbor',
  'fabric.editor.addRowAbove': 'Pridať riadok nad',
  'fabric.editor.addRowBelow': 'Pridať riadok pod',
  'fabric.editor.addUpdatedAltText': 'Pridať alternatívny text',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Použitie nástroja Atlassian Intelligence na vyhľadávanie položiek činností a ich zobrazenie na paneli',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Panel položiek činností (beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Použitie nástroja Atlassian Intelligence na vytvorenie súhrnu tejto stránky a jeho zobrazenie na paneli',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panel súhrnu stránky (beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Vybraný obsah',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Generuje obsah, ktorý sa má vložiť do aktualizácie.',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Vytvorí súhrn obsahu aktualizácie.',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Vytvoriť',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel':
    'Opýtať sa nástroja Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.insert': 'Vložiť',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Vložiť hore',
  'fabric.editor.ai.config.item.action.insertBelow': 'Vložiť nižšie',
  'fabric.editor.ai.config.item.action.replace': 'Nahradiť',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Nahradiť názov',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Názov nesmie obsahovať viac než {maxLength} znakov.',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Otvoriť v chate',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo Agent',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Skráti obsah, aby bol stručnejší.',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Skrátiť aktualizáciu',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Vytvorí opis požiadavky na začlenenie zmien so súhrnom zmien.',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Vytvoriť opis požiadavky na začlenenie zmien',
  'fabric.editor.ai.config.item.brainstorm.description': 'Vygeneruje zoznam nápadov na zadanú tému.',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Povedzte mi tému...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorming',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorming',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Zmení tón obsahu na neformálny.',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Príležitostné',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Príležitostné',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Zmeniť tón na neformálny',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Zmení tón obsahu na vzdelávací.',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Vzdelávací',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Vzdelávací',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Zmeniť tón na vzdelávací',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Zmení tón obsahu na empatický.',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatický',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatický',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Zmeniť tón na empatický',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Zmeniť tón na...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Zmení tón obsahu na neutrálny.',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutrálny',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutrálny',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Zmeniť tón na neutrálny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Zmení tón obsahu na profesionálny.',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Profesionálny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Profesionálny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Zmeniť tón na profesionálny',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Preformátuje obsah na zoznam s odrážkami.',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Konvertovať na zoznam s odrážkami',
  'fabric.editor.ai.config.item.convertToTable.description': 'Preformátuje obsah na tabuľku s nadpismi.',
  'fabric.editor.ai.config.item.convertToTable.title': 'Konvertovať na tabuľku',
  'fabric.editor.ai.config.item.draftReply.description':
    'Vytvorí odpoveď na základe problémov podobných tomu, na ktorom pracujete.',
  'fabric.editor.ai.config.item.draftReply.title': 'Vytvoriť odpoveď',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Opraví pravopisné a gramatické chyby.',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Pravopis a gramatika',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Oprava pravopisu a gramatiky',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Zlepší zrozumiteľnosť, štruktúru a tón textu, aby bol zaujímavejší a ľahšie pochopiteľný.',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Vylepšiť znenie',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Vylepšiť znenie',
  'fabric.editor.ai.config.item.findActionItems.description': 'Vyhľadá položky činnosti vo vami poskytnutom obsahu.',
  'fabric.editor.ai.config.item.findActionItems.title': 'Vyhľadať položky činnosti',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Vyberte si z nasledujúcich možností (bezplatné generovanie je v súčasnosti v aplikácii Elevate vypnuté)',
  'fabric.editor.ai.config.item.generateContent.promptHint':
    'Napíšte text pomocou AI alebo vyberte z nižšie uvedených možností',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Prepracovanie opisu problému na základe typu problému',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Vylepšiť opis',
  'fabric.editor.ai.config.item.makeLonger.description': 'Rozšíri obsah na základe kontextu, ktorý poskytnete.',
  'fabric.editor.ai.config.item.makeLonger.title': 'Predĺžiť',
  'fabric.editor.ai.config.item.range.agent.description': 'Žiadny popis',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Povedzte agentovi, aby napísal čokoľvek, alebo si vyberte z nasledujúcich možností',
  'fabric.editor.ai.config.item.rephrase.description': 'Vytvorí návrh na prepísanie vašich viet.',
  'fabric.editor.ai.config.item.rephrase.title': 'Preformulovať',
  'fabric.editor.ai.config.item.shorten.description': 'Skráti obsah, aby bol stručnejší.',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Skrátiť',
  'fabric.editor.ai.config.item.shorten.title': 'Skrátiť',
  'fabric.editor.ai.config.item.suggest.description': 'Navrhne názov obsahu, ktorý poskytnete.',
  'fabric.editor.ai.config.item.suggest.title': 'Navrhnúť názov',
  'fabric.editor.ai.config.item.summarize.description':
    'Vytvorí súhrn textu, na ktorom pracujete, a zvýrazní v ňom kľúčové body.',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Zhrnutie zapísaného textu',
  'fabric.editor.ai.config.item.summarize.title': 'Zhrnutie zapísaného textu',
  'fabric.editor.ai.config.item.translate.czech': 'Čeština',
  'fabric.editor.ai.config.item.translate.danish': 'Dánčina',
  'fabric.editor.ai.config.item.translate.dutch': 'Holandčina',
  'fabric.editor.ai.config.item.translate.english': 'Angličtina',
  'fabric.editor.ai.config.item.translate.finnish': 'Fínčina',
  'fabric.editor.ai.config.item.translate.french': 'Francúzština',
  'fabric.editor.ai.config.item.translate.german': 'Nemčina',
  'fabric.editor.ai.config.item.translate.hungarian': 'Maďarčina',
  'fabric.editor.ai.config.item.translate.italian': 'Taliančina',
  'fabric.editor.ai.config.item.translate.japanese': 'Japončina',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Preložiť',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Preložiť do jazyka...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Nórčina',
  'fabric.editor.ai.config.item.translate.russian': 'Ruština',
  'fabric.editor.ai.config.item.translate.spanish': 'Španielčina',
  'fabric.editor.ai.config.item.translate.swedish': 'Švédčina',
  'fabric.editor.ai.config.item.translate.thai': 'Thajčina',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Preloží text, na ktorom pracujete, do čínštiny (zjednodušenej).',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Preložiť do čínštiny (zjednodušenej)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Preloží text, na ktorom pracujete, do čínštiny (tradičnej).',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Preložiť do čínštiny (tradičnej)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Preloží text, na ktorom pracujete, do češtiny.',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Preložiť do češtiny',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Preloží text, na ktorom pracujete, do dánčiny.',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Preložiť do dánčiny',
  'fabric.editor.ai.config.item.translateTo.dutch.description': 'Preloží text, na ktorom pracujete, do holandčiny.',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Preložiť do holandčiny',
  'fabric.editor.ai.config.item.translateTo.english.description': 'Preloží text, na ktorom pracujete, do angličtiny.',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Preložiť do angličtiny',
  'fabric.editor.ai.config.item.translateTo.finnish.description': 'Preloží text, na ktorom pracujete, do fínčiny.',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Preložiť do fínčiny',
  'fabric.editor.ai.config.item.translateTo.french.description': 'Preloží text, na ktorom pracujete, do francúzštiny.',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Preložiť do francúzštiny',
  'fabric.editor.ai.config.item.translateTo.german.description': 'Preloží text, na ktorom pracujete, do nemčiny.',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Preložiť do nemčiny',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Preloží text, na ktorom pracujete, do maďarčiny.',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Preložiť do maďarčiny',
  'fabric.editor.ai.config.item.translateTo.italian.description': 'Preloží text, na ktorom pracujete, do taliančiny.',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Preložiť do taliančiny',
  'fabric.editor.ai.config.item.translateTo.japanese.description': 'Preloží text, na ktorom pracujete, do japončiny.',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Preložiť do japončiny',
  'fabric.editor.ai.config.item.translateTo.korean.description': 'Preloží text, na ktorom pracujete, do kórejčiny.',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Preložiť do kórejčiny',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Preloží text, na ktorom pracujete, do nórčiny.',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Preložiť do nórčiny',
  'fabric.editor.ai.config.item.translateTo.polish.description': 'Preloží text, na ktorom pracujete, do poľštiny.',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Preložiť do poľštiny',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Preloží text, na ktorom pracujete, do portugalčiny (brazílskej).',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Preložiť do portugalčiny (brazílskej)',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Preloží text, na ktorom pracujete, do ruštiny.',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Preložiť do ruštiny',
  'fabric.editor.ai.config.item.translateTo.spanish.description': 'Preloží text, na ktorom pracujete, do španielčiny.',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Preložiť do španielčiny',
  'fabric.editor.ai.config.item.translateTo.swedish.description': 'Preloží text, na ktorom pracujete, do švédčiny.',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Preložiť do švédčiny',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Preloží text, na ktorom pracujete, do thajčiny.',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Preložiť do thajčiny',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Preloží text, na ktorom pracujete, do turečtiny.',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Preložiť do turečtiny',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Preloží text, na ktorom pracujete, do ukrajinčiny.',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Preložiť do ukrajinčiny',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Preloží text, na ktorom pracujete, do vietnamčiny.',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Preložiť do vietnamčiny',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Zmeniť tón',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Prepísať',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Preložiť',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Nadpis stránky',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Stránka',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vyskytol sa problém pri vkladaní odpovede. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Vyskytol sa problém pri generovaní ukážky. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'V poslednom čase sme dostali príliš veľa požiadaviek na Atlassian Intelligence (AI). Skúste to o pár minút znova alebo si prečítajte o <link>nadmernom používaní AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Nepodarilo sa načítať odpoveď. Vaše zadanie alebo odpoveď prekročila limit pre túto požiadavku. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Vyskytol sa problém. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.experience.apiError': 'Nepodarilo sa nám získať odpoveď, skúste to znova.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Vaše zadanie alebo obsah nemusí byť v súlade s našimi Zásadami prijateľného používania. V prípade potreby si ich prečítajte a pozrite si naše <link>Zásady prijateľného používania</link>. Ak problém pretrváva, skúste iné zadanie alebo obsah.',
  'fabric.editor.ai.experience.browseMore.agents': 'Prehľadávať agentov',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Chcete zahodiť svoje zadanie?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Chcete zahodiť svoju odpoveď?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'Bezplatné generovanie je v súčasnosti v aplikácii Elevate vypnuté.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Teraz môžete vkladať prepojenia 🔗 na obsah aplikácií Jira a Confluence do svojich zadaní.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Založené na technológii Rovo',
  'fabric.editor.ai.experience.hipaaContentError':
    'Nástroj Atlassian Intelligence nemohol spracovať vašu požiadavku, pretože v obsahu sú prepojenia na obsah s obmedzeným prístupom podľa zákona HIPAA. Odstráňte príslušné prepojenia a skúste to znova.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Obsah je príliš krátky na vytvorenie súhrnu. Pridajte ďalšie položky a skúste to znova.',
  'fabric.editor.ai.experience.internalServerError':
    'Nástroj Atlassian Intelligence (AI) neodpovedá. Skúste to znova neskôr alebo <link>skontrolujte stav nástroja AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Generuje sa',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analýza: Preskúmava sa vaša otázka.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Vyhľadáva sa – počkajte na vyhľadanie informácií.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Vyhľadáva sa – počkajte na prehľadanie aplikácie Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Vyhľadáva sa – počkajte na prehľadanie stránky.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Žiadne výsledky',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Nástroj Atlassian Intelligence v súčasnosti nemá žiadne návrhy. Nebojte sa vyskúšať iné zadanie alebo obsah.',
  'fabric.editor.ai.experience.showMoreButton': 'Zobraziť viac',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Akcie',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenti',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Zdroj vedomostí',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agenti Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agenti Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Použiť agenta Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Použiť všeobecné vedomosti',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Použiť vedomosti z vašej organizácie',
  'fabric.editor.ai.proactive.askAIButtonLabel.non-final': 'Opýtať sa AI',
  'fabric.editor.ai.proactive.beta.label.non-final': 'BETA',
  'fabric.editor.ai.proactive.close.label.non-final': 'Zatvoriť',
  'fabric.editor.ai.proactive.enableSuggestionsButtonLabel.non-final': 'Zapnúť',
  'fabric.editor.ai.proactive.enableSuggestionsState.description.non-final':
    'Ak chcete rýchlo zobraziť ukážku vylepšení obsahu, zapnite navrhované úpravy.',
  'fabric.editor.ai.proactive.enableSuggestionsState.title.non-final': 'Vy tvoríte. My vylepšujeme.',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Vyskytol sa problém pri generovaní ukážky. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Vyskytol sa problém. Zatvorte dialógové okno a skúste to znova.',
  'fabric.editor.ai.proactive.findingMoreSuggestionsLoadingLabel.non-final': 'Hľadajú sa ďalšie návrhy',
  'fabric.editor.ai.proactive.findingSuggestionsLabel.non-final': 'Hľadajú sa návrhy',
  'fabric.editor.ai.proactive.findingSuggestionsLoadingLabel.non-final': 'Hľadajú sa návrhy',
  'fabric.editor.ai.proactive.loading.iconAltText.non-final': 'Ikona načítavania',
  'fabric.editor.ai.proactive.moreActions.label.non-final': 'Ďalšie akcie',
  'fabric.editor.ai.proactive.moreMenu.giveFeedback.non-final': 'Poskytnúť spätnú väzbu',
  'fabric.editor.ai.proactive.moreMenu.label.non-final': 'viac',
  'fabric.editor.ai.proactive.moreMenu.manageSuggestions.non-final': 'Spravovať návrhy',
  'fabric.editor.ai.proactive.moreMenu.manageSuggestionsTitle.non-final': 'Spravovať návrhy',
  'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsDescription.non-final':
    'Pomocou panelov môžete zvýrazniť správu.',
  'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsTitle.non-final': 'Panely',
  'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsDescription.non-final':
    'Prepínač na zapnutie alebo vypnutie navrhovaných úprav.',
  'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsTitle.non-final': 'Všetky návrhy',
  'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelDescription.non-final':
    'Premeňte text na červený panel pre chybu.',
  'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelTitle.non-final': 'Panel chýb',
  'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphDescription.non-final':
    'Návrhy na písanie, zoznamy, štruktúru obsahu a pravopis.',
  'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphTitle.non-final': 'Vylepšiť obsah',
  'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelDescription.non-final':
    'Premeňte text na modrý panel pre informácie.',
  'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelTitle.non-final': 'Informačný panel',
  'fabric.editor.ai.proactive.moreMenu.toggleNotePanelDescription.non-final':
    'Premeňte text na fialový panel pre poznámku.',
  'fabric.editor.ai.proactive.moreMenu.toggleNotePanelTitle.non-final': 'Panel poznámok',
  'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphDescription.non-final':
    'Ak chcete oddeliť kľúčové nápady, pridajte zlom odseka.',
  'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphTitle.non-final': 'Zlom odseka',
  'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelDescription.non-final':
    'Premeňte text na zelený panel úspešnej akcie.',
  'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelTitle.non-final': 'Panel úspechov',
  'fabric.editor.ai.proactive.moreMenu.toggleTableDescription.non-final':
    'Ak chcete zlepšiť čitateľnosť obsahu v tabuľke, naformátujte ho.',
  'fabric.editor.ai.proactive.moreMenu.toggleTableTitle.non-final': 'Tabuľka',
  'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelDescription.non-final':
    'Premeňte text na žltý panel pre varovanie.',
  'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelTitle.non-final': 'Panel výstrah',
  'fabric.editor.ai.proactive.noSuggestionsState.description.non-final':
    'Môžete tiež požiadať nástroj AI, aby vylepšil vašu stránku, pomocou požiadaviek, ako je <i>Pridať obsah</i> alebo <i>Vytvoriť nadpisy</i>.',
  'fabric.editor.ai.proactive.noSuggestionsState.title.non-final': 'Tu sa zobrazia návrhy',
  'fabric.editor.ai.proactive.preview.dismissProactiveRecommendation.non-final': 'Zrušiť',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Vložiť nižšie',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Nahradiť',
  'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.description.non-final':
    'Ak chcete, aby vaša správa vynikla, použite červený panel pre chybu.',
  'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.title.non-final': 'Zarámovať do panelu pre chybu',
  'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.description.non-final':
    'Ak chcete, aby vaša správa vynikla, použite modrý panel pre informácie.',
  'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.title.non-final': 'Zarámovať do panela pre informácie',
  'fabric.editor.ai.proactive.recommendation.convertToNotePanel.description.non-final':
    'Ak chcete, aby vaša správa vynikla, použite fialový panel pre poznámku.',
  'fabric.editor.ai.proactive.recommendation.convertToNotePanel.title.non-final': 'Zarámovať do panela pre poznámku',
  'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.description.non-final':
    'Ak chcete, aby vaša správa vynikla, použite zelený panel úspešnej akcie.',
  'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.title.non-final':
    'Zarámovať do panela úspešnej akcie',
  'fabric.editor.ai.proactive.recommendation.convertToTable.description.non-final':
    'Ak chcete zlepšiť čitateľnosť obsahu v tabuľke, naformátujte ho.',
  'fabric.editor.ai.proactive.recommendation.convertToTable.title.non-final': 'Formátovať v tabuľke',
  'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.description.non-final':
    'Ak chcete, aby vaša správa vynikla, použite žltý panel pre varovanie.',
  'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.title.non-final': 'Zarámovať do panela pre varovanie',
  'fabric.editor.ai.proactive.recommendation.default.description.non-final': 'Návrh na vylepšenie obsahu.',
  'fabric.editor.ai.proactive.recommendation.default.title.non-final': 'Návrh',
  'fabric.editor.ai.proactive.recommendation.dismiss.button.non-final': 'Zrušiť',
  'fabric.editor.ai.proactive.recommendation.formatParagraph.description.non-final':
    'Objasní znenie a štruktúru obsahu.',
  'fabric.editor.ai.proactive.recommendation.formatParagraph.title.non-final': 'Vylepšiť obsah',
  'fabric.editor.ai.proactive.recommendation.formatParagraphClarity.description.non-final':
    'Zjednoduší formulácie a gramatiku.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphClarity.title.non-final': 'Objasniť znenie',
  'fabric.editor.ai.proactive.recommendation.formatParagraphList.description.non-final':
    'Premeňte obsah na skenovateľný zoznam.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphList.title.non-final': 'Vytvoriť zoznam',
  'fabric.editor.ai.proactive.recommendation.formatParagraphSpellcheck.description.non-final':
    'Vyhľadajte a opravte pravopisné chyby.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphSpellcheck.title.non-final': 'Opraviť pravopis',
  'fabric.editor.ai.proactive.recommendation.formatParagraphStructure.description.non-final':
    'Pridajte zlomy odsekov a nadpisy.',
  'fabric.editor.ai.proactive.recommendation.formatParagraphStructure.title.non-final': 'Vylepšiť štruktúru',
  'fabric.editor.ai.proactive.recommendation.preview.button.non-final': 'Ukážka',
  'fabric.editor.ai.proactive.recommendation.replace.button.non-final': 'Nahradiť',
  'fabric.editor.ai.proactive.recommendation.splitParagraph.description.non-final':
    'Ak chcete oddeliť kľúčové nápady, pridajte zlom odseka.',
  'fabric.editor.ai.proactive.recommendation.splitParagraph.title.non-final': 'Rozdeliť odsek',
  'fabric.editor.ai.proactive.reloadSuggestionsButtonLabel.non-final': 'Zobraziť predchádzajúce návrhy',
  'fabric.editor.ai.proactive.reloadSuggestionsState.description.non-final': 'Tu sa zobrazia prípadné nové návrhy.',
  'fabric.editor.ai.proactive.reloadSuggestionsState.title.non-final': 'Váš obsah vyzerá dobre',
  'fabric.editor.ai.proactive.spellingAndGrammar.label.non-final': 'Pravopis a gramatika',
  'fabric.editor.ai.proactive.suggestions.title.non-final': 'Návrhy',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Žiadosti o generovanie obsahu, ktoré odkazujú na adresy URL, sú vo fáze beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Zvýraznite výraz alebo skratku',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definovať',
  'fabric.editor.ai.toolbar.askAI.title': 'Opýtať sa AI',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Vylepšiť znenie',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Požiada nástroj Atlassian Intelligence, aby vylepšil znenie vybraného obsahu.',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Vyskúšať AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Otvoriť Atlassian Intelligence',
  'fabric.editor.alignCenter': 'Zarovnať do stredu',
  'fabric.editor.alignImageCenter': 'Zarovnať do stredu',
  'fabric.editor.alignImageLeft': 'Zarovnať vľavo',
  'fabric.editor.alignImageRight': 'Zarovnať vpravo',
  'fabric.editor.alignLeft': 'Zarovnať vľavo',
  'fabric.editor.alignRight': 'Zarovnať vpravo',
  'fabric.editor.alignTableCenter': 'Zarovnať do stredu',
  'fabric.editor.alignTableLeft': 'Zarovnať vľavo',
  'fabric.editor.alignment': 'Zarovnanie textu',
  'fabric.editor.altText': 'Všetok text',
  'fabric.editor.alttext.validation': 'Vymažte z alternatívneho textu všetky špeciálne znaky.',
  'fabric.editor.annotationToolbar': 'Panel s nástrojmi poznámok',
  'fabric.editor.backLink': 'Vrátiť sa',
  'fabric.editor.backgroundColor': 'Farba pozadia',
  'fabric.editor.blockCardUnavailable': 'Vnorené prepojenie je v uzle {node} a jeho zobrazenie nemožno zmeniť',
  'fabric.editor.blockControlDelete': 'Odstrániť',
  'fabric.editor.blockControlDragHandleMove': 'Potiahnutím presuňte',
  'fabric.editor.blockControlDragHandleRearrange': 'Potiahnutím zmeňte usporiadanie',
  'fabric.editor.blockControlInsert': 'Vložiť',
  'fabric.editor.blockControlMoveDown': 'Posunúť dolu',
  'fabric.editor.blockControlMoveLeft': 'Vľavo',
  'fabric.editor.blockControlMoveRight': 'Vpravo',
  'fabric.editor.blockControlMoveUp': 'Posunúť hore',
  'fabric.editor.blockControlMovedDown': 'Obsah bol presunutý nadol.',
  'fabric.editor.blockControlMovedUp': 'Obsah bol presunutý nahor.',
  'fabric.editor.blockDescription': 'Zobraziť viac informácií o prepojení, vrátane súhrnu a činností',
  'fabric.editor.blockTitle': 'Karta',
  'fabric.editor.blockquote': 'citácia',
  'fabric.editor.blockquote.description': 'Vložiť citát alebo citáciu',
  'fabric.editor.blockquote2': 'Citácia',
  'fabric.editor.bold': 'Hrubé',
  'fabric.editor.bug': 'Softvérový problém',
  'fabric.editor.canNotSortTable': "⚠️ You can't sort a table with merged cells",
  'fabric.editor.cancelButton': 'Zrušiť',
  'fabric.editor.captionPlaceholder': 'Pridajte titulok',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Pridajte titulok – dvojitým kliknutím zobrazíte ukážku',
  'fabric.editor.cardFloatingControls': 'Možnosti karty',
  'fabric.editor.cellBackground': 'Pozadie buniek',
  'fabric.editor.cellOptions': 'Možnosti bunky',
  'fabric.editor.checkUncheckActionItem': 'Prepnúť položku činnosti',
  'fabric.editor.clearAltTextEdit': 'Vymazať alternatívny text',
  'fabric.editor.clearCells':
    '{0, plural, one {Vymazať bunku} few {Vymazať bunky} many {Vymazať bunky} other {Vymazať bunky}}',
  'fabric.editor.clearFormatting': 'Vymazať formátovanie',
  'fabric.editor.clearLink': 'Vymazať prepojenie',
  'fabric.editor.clearLinkText': 'Vymazať text',
  'fabric.editor.closeAltTextEdit': 'Späť',
  'fabric.editor.closeFindReplaceDialog': 'Zatvoriť',
  'fabric.editor.closeHelpDialog': 'Zavrieť dialógové okno pomocníka',
  'fabric.editor.code': 'Kód',
  'fabric.editor.code.on': '{textFormattingOff}, formátovanie kódu zapnuté',
  'fabric.editor.codeBidiWarningLabel':
    'Obojsmerné znaky menia poradie vypísania textu. To by sa mohlo použiť na skrytie škodlivého kódu.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Skopírované!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopírovať ako text',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Vypnúť obalenie',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Zapnúť obalenie',
  'fabric.editor.codeblock': 'Zlomok kódu',
  'fabric.editor.codeblock.description': 'Zobraziť kód so zvýraznenou syntaxou',
  'fabric.editor.collapseNode': 'Zbaliť obsah',
  'fabric.editor.collapseTable': 'Zbaliť tabuľku',
  'fabric.editor.columnDragHandle': 'Možnosti stĺpca',
  'fabric.editor.columnMovedLeft': 'Stĺpec bol presunutý doľava na pozíciu {index} z {total}.',
  'fabric.editor.columnMovedRight': 'Stĺpec bol presunutý doprava na pozíciu {index} z {total}.',
  'fabric.editor.columnSelected': 'Bol vybratý stĺpec {index} z {total}.',
  'fabric.editor.columns': 'Rozloženia',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Vložiť {numberOfColumns} rovnaký stĺpec} few {Vložiť {numberOfColumns} rovnaké stĺpce} many {Vložiť {numberOfColumns} rovnakých stĺpcov} other {Vložiť {numberOfColumns} rovnakých stĺpcov}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Vložiť rozloženie s jedným stĺpcom',
  'fabric.editor.columns.description': 'Rozdeľte stránku pomocou sekcií',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Bol vložený stĺpec.} few {Boli vložené {count} stĺpce.} many {Bolo vložených {count} stĺpcov.} other {Bolo vložených {count} stĺpcov.}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Stĺpec bol odstránený} few {Boli odstránené {count} stĺpce} many {Bolo odstránených {count} stĺpcov} other {Bolo odstránených {count} stĺpcov}}',
  'fabric.editor.configFailedToLoad': 'Nahratie zlyhalo',
  'fabric.editor.configPanel.cancel': 'Zrušiť',
  'fabric.editor.configPanel.close': 'Zatvoriť',
  'fabric.editor.configPanel.customSelect.createOption': 'Vytvoriť',
  'fabric.editor.configPanel.dateRange.custom.from': 'Od',
  'fabric.editor.configPanel.dateRange.custom.to': 'Do',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Collapse',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Rozšírenie',
  'fabric.editor.configPanel.dateRange.option.custom': 'Vlastné',
  'fabric.editor.configPanel.documentation': 'Dokumentácia',
  'fabric.editor.configPanel.errorBoundary.note':
    'Dali sme to vedieť tímu. Túto stránku môžete naďalej upravovať a publikovať alebo môžete skontrolovať chybovú konzolu, kde nájdete ďalšie informácie.',
  'fabric.editor.configPanel.errorBoundary.title': 'Vyskytol sa problém.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio':
    '„IsMultiple“ a „style: radio“ nie je možné kombinovať',
  'fabric.editor.configPanel.formType.addField': 'Pridať pole',
  'fabric.editor.configPanel.formType.removeField': 'Odstrániť pole',
  'fabric.editor.configPanel.help': 'Potrebujete pomoc?',
  'fabric.editor.configPanel.invalid': 'Neplatné pole',
  'fabric.editor.configPanel.required': 'Povinné pole',
  'fabric.editor.configPanel.submit': 'Odoslať',
  'fabric.editor.copiedToClipboard': 'Skopírované!',
  'fabric.editor.copyToClipboard': 'Kopírovať',
  'fabric.editor.cornerControl': 'Zvýrazniť tabuľku',
  'fabric.editor.createComment': 'Komentár',
  'fabric.editor.createCommentDisabled':
    'Môžete komentovať iba text, nadpisy, emodži, dátumy, zmienky, odkazy a stavy.',
  'fabric.editor.createCommentInvalid': 'Komentovať môžete len text a nadpisy.',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Rozumiem',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Teraz môžete pridať komentáre k vnoreným prvkom, ako sú prepojenia, dátumy, stavy a zmienky.',
  'fabric.editor.customPanel': 'Vlastný panel',
  'fabric.editor.customPanel.description': 'Pridať poznámku s emodži a farebným pozadím',
  'fabric.editor.datasource.assetsObjects.description':
    'Vložte objekty z komponenty Assets v aplikácii Jira Service Management pomocou vyhľadávania a filtrovania.',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Aktíva',
  'fabric.editor.datasource.confluenceSearch': 'Vložiť zoznam Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Vložte zoznam výsledkov vyhľadávania z aplikácie Confluence s rozšíreným vyhľadávaním, filtrovaním a konfiguráciou.',
  'fabric.editor.datasource.jiraIssue': 'Problémy Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Vkladajte problémy Jira z aplikácie Jira Cloud s vylepšeným vyhľadávaním, filtrovaním a konfiguráciou.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Vkladajte pracovné položky Jira z aplikácie Jira Cloud s vylepšeným vyhľadávaním, filtrovaním a konfiguráciou.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Pracovné položky Jira',
  'fabric.editor.datasourceAppearanceTitle': 'List',
  'fabric.editor.datasourceTitle': 'Upraviť vyhľadávací dotaz',
  'fabric.editor.date': 'Dátum',
  'fabric.editor.date.description': 'Pridať dátum pomocou kalendára',
  'fabric.editor.decision': 'Rozhodnutie',
  'fabric.editor.decision.description': 'Zaznamenajte rozhodnutia, aby sa mohli jednoducho sledovať',
  'fabric.editor.decisionPlaceholder': 'Pridať rozhodnutie...',
  'fabric.editor.decreaseSize': 'Zmeniť veľkosť tabuľky alebo média',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Odstrániť',
  'fabric.editor.description': 'Popis',
  'fabric.editor.displayBlock': 'Zobraziť ako kartu',
  'fabric.editor.displayEmbed': 'Zobraziť ako vložený objekt',
  'fabric.editor.displayInline': 'Zobraziť vo vnútri',
  'fabric.editor.displayLink': 'Zobraziť ako text',
  'fabric.editor.displayOptionUnavailableInParentNode':
    'Táto možnosť zobrazenia nie je k dispozícii vo vnútri uzla {node}.',
  'fabric.editor.displayText': 'Text na zobrazenie',
  'fabric.editor.distributeColumns': 'Rovnomerne rozdeliť stĺpce',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Zobraziť interaktívnu ukážku prepojenia',
  'fabric.editor.edit': 'Upraviť',
  'fabric.editor.edit.datasource': 'Upraviť vyhľadávací dotaz',
  'fabric.editor.edit.searchInput': 'Pridať prepojenie',
  'fabric.editor.editAccessTitle': 'Potrebujete prístup na úpravy',
  'fabric.editor.editAltText': 'Upraviť alternatívny text',
  'fabric.editor.editDatasourceStandalone': 'Upraviť',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Upraviť vyhľadávací dotaz',
  'fabric.editor.editDateText': 'Upraviť dátum',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Upraviť vyhľadávací dotaz',
  'fabric.editor.editDropdownEditLinkTitle': 'Upraviť prepojenie',
  'fabric.editor.editDropdownExpandIconLabel': 'Rozbaliť rozbaľovaciu ponuku',
  'fabric.editor.editDropdownTriggerTitle': 'Upraviť',
  'fabric.editor.editLink': 'Upraviť prepojenie',
  'fabric.editor.editMode.inviteToEditButton.title': 'Pozvať na úpravy',
  'fabric.editor.editStatusColor': 'Upraviť farbu stavu',
  'fabric.editor.editStatusText': 'Upraviť stav',
  'fabric.editor.editableContentLabel': 'Upraviteľný obsah',
  'fabric.editor.editorHelp': 'Pomoc editora',
  'fabric.editor.editors': 'Editori',
  'fabric.editor.elementBrowser.help': 'Pomocník',
  'fabric.editor.elementInsertSidePanel.title': 'Vložiť',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Správa',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Všetko',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Komunikácia',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Obsah Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Vývoj',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Externý obsah',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formátovanie',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Médiá',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigácia',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Vytváranie správ',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Grafika a obrázky',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Nič sa nezhoduje s vašim vyhľadávaním',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Skúste hľadať s použitím iného výrazu alebo objavte nové aplikácie pre produkty Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Preskúmajte Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Vyhľadávaniu nezodpovedajú žiadne výsledky.} one {V predvolenom nastavení je k dispozícii {count} návrh.} few {V predvolenom nastavení sú k dispozícii {count} návrhy.} many {V predvolenom nastavení je k dispozícii {count} návrhov.} other {V predvolenom nastavení je k dispozícii {count} návrhov.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Vyhľadávaniu nezodpovedajú žiadne výsledky.} one {Pre zadaný text je k dispozícii {count} návrh.} few {Pre zadaný text sú k dispozícii {count} návrhy.} many {Pre zadaný text je k dispozícii {count} návrhov.} other {Pre zadaný text je k dispozícii {count} návrhov.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Zadať',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Vyhľadať',
  'fabric.editor.elementbrowser.sidebar.heading': 'Prehliadať',
  'fabric.editor.embedTitle': 'Vložiť',
  'fabric.editor.emoji': 'Emodži',
  'fabric.editor.emoji.description': 'Na vyjadrenie nápadov 🎉 a emócií 😄 použite emodži',
  'fabric.editor.emptyLink': 'Zadajte prepojenie.',
  'fabric.editor.emptySearchResults': 'Nenašli sa žiadne výsledky.',
  'fabric.editor.emptySearchResultsSuggestion':
    'Stlačte tlačidlo {buttonName} a vyhľadajte položky, ktoré chcete vložiť.',
  'fabric.editor.epic': 'Epika',
  'fabric.editor.error': 'Chyba',
  'fabric.editor.errorPanel': 'Panel chýb',
  'fabric.editor.errorPanel.description': 'Vyvolanie chýb vo farebnom paneli',
  'fabric.editor.expand': 'Rozšírenie',
  'fabric.editor.expand.description': 'Vložiť rozšírenie',
  'fabric.editor.expandAriaLabel': 'Pomenujte toto rozšírenie',
  'fabric.editor.expandDefaultTitle': 'Kliknutím sem rozšírite...',
  'fabric.editor.expandNode': 'Rozšíriť obsah',
  'fabric.editor.expandPlaceholder': 'Pomenujte toto rozšírenie...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Odstránením položky {nodeName} sa od nej odpojí všetko, čo je k nej pripojené.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Prebieha odstraňovanie',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Odstrániť',
  'fabric.editor.extension.deleteElementTitle': 'Odstrániť prvok',
  'fabric.editor.extension.sourceNoTitledName': 'tento prvok',
  'fabric.editor.extensions.config-panel.save-indicator': 'Všetky zmeny sa vždy automaticky uložia.',
  'fabric.editor.externalExtensionsHeading': 'Aplikácie',
  'fabric.editor.externalMediaFile': 'Externý súbor médií',
  'fabric.editor.failed_to_upload': 'Nahrávanie zlyhalo',
  'fabric.editor.feedbackDialog': 'Poskytnúť spätnú väzbu',
  'fabric.editor.feedbackDialog.description': 'Podeľte sa s nami o svoje skúsenosti s novým editorom',
  'fabric.editor.find': 'Nájsť',
  'fabric.editor.findNext': 'Nájsť ďalší',
  'fabric.editor.findPrevious': 'Nájsť predchádzajúci',
  'fabric.editor.findReplaceToolbarButton': 'Nájsť a nahradiť',
  'fabric.editor.fiveColumns': 'Rozloženie s 5 stĺpcami',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Zrušiť',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Odstrániť aj pripojené prvky',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 pripojený prvok)} few {{name} (+{amount,number} pripojené prvky)} many {{name} (+{amount,number} pripojených prvkov)} other {{name} (+{amount,number} pripojených prvkov)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Určite?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    'Ovládacie prvky na plávajúcom paneli s nástrojmi boli otvorené.',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Plávajúci panel s nástrojmi',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Možnosti rozloženia',
  'fabric.editor.floatingToolbar.scrollLeft': 'Posunúť doľava',
  'fabric.editor.floatingToolbar.scrollRight': 'Posunúť doprava',
  'fabric.editor.focusTableResizeHandle': 'Zamerať na rukoväť na zmenu veľkosti tabuľky',
  'fabric.editor.fourColumns': 'Rozloženie so 4 stĺpcami',
  'fabric.editor.headerColumn': 'Stĺpec záhlavia',
  'fabric.editor.headerRow': 'Riadok záhlavia',
  'fabric.editor.heading1': 'Nadpis 1',
  'fabric.editor.heading1Description': 'Použiť pre nadpis najvyššej úrovne',
  'fabric.editor.heading2': 'Nadpis 2',
  'fabric.editor.heading2Description': 'Použiť pre kľúčové časti',
  'fabric.editor.heading3': 'Nadpis 3',
  'fabric.editor.heading3Description': 'Použiť pre podriadené časti a nadpisy skupín',
  'fabric.editor.heading4': 'Nadpis 4',
  'fabric.editor.heading4Description': 'Použiť pre podnadpisy',
  'fabric.editor.heading5': 'Nadpis 5',
  'fabric.editor.heading5Description': 'Použiť pre zoskupenie položiek zoznamu',
  'fabric.editor.heading6': 'Nadpis 6',
  'fabric.editor.heading6Description': 'Použiť pre nadpisy nízkej úrovne',
  'fabric.editor.headingLink.ascOrderLabel': 'Zoradiť stĺpec zostupne (od Z do A)',
  'fabric.editor.headingLink.descOrderLabel': 'Zrušiť zoradenie',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Softvérový problém',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Problém',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Pracovná položka',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Stránka',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Príbeh',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Úloha',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Nemôžete zoradiť tabuľku so zlúčenými bunkami',
  'fabric.editor.headingLink.noOrderLabel': 'Zoradiť stĺpce vzostupne (od A do Z)',
  'fabric.editor.help': 'Pomoc',
  'fabric.editor.help.description': 'Prehľadávať všetky klávesové skratky a možnosti značenia',
  'fabric.editor.helpDialogTips': 'Stlačením tlačidla {keyMap} rýchlo kedykoľvek otvorte tento dialóg',
  'fabric.editor.highlight': 'Zvýrazniť farbu',
  'fabric.editor.highlightColor': 'Prepnúť farebnú paletu zvýraznenia',
  'fabric.editor.highlightFloatingToolbar': 'Zvýrazniť',
  'fabric.editor.horizontalRule': 'Rozdeľovač',
  'fabric.editor.horizontalRule.description': 'Oddelenie obsahu vodorovnou čiarou',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Vložiť alebo vyhľadať prepojenie',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Pri zadávaní do poľa sa nižšie zobrazia návrhy.',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {Nenašli sa žiadne výsledky} one {Našiel sa {count,number} výsledok.} few {Našli sa {count,number} výsledky.} many {Našlo sa {count,number} výsledkov.} other {Našlo sa {count,number} výsledkov.}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Zobrazovaný text (voliteľný)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Vložiť alebo vyhľadať prepojenie',
  'fabric.editor.image': 'Obrázok',
  'fabric.editor.image.fullWidthLabel': 'Celá šírka',
  'fabric.editor.imageBorderBold': 'Hrubé',
  'fabric.editor.imageBorderColor': 'Farba',
  'fabric.editor.imageBorderMedium': 'Stredná',
  'fabric.editor.imageBorderOptions': 'Možnosti ohraničenia',
  'fabric.editor.imageBorderSize': 'Veľkosť',
  'fabric.editor.imageBorderSubtle': 'Jemný',
  'fabric.editor.improvement': 'Vylepšenie',
  'fabric.editor.increaseSize': 'Zväčšiť tabuľku alebo médium',
  'fabric.editor.indent': 'Zarážka',
  'fabric.editor.info': 'Informácie',
  'fabric.editor.infoPanel': 'Informačný panel',
  'fabric.editor.infoPanel.description': 'Zvýrazniť informácie vo farebnom paneli',
  'fabric.editor.inlineConfigureLink': 'Konfigurovať prepojenie',
  'fabric.editor.inlineDescription': 'Zobraziť prepojenie ako vnorený text',
  'fabric.editor.inlineGoToLink': 'Prejsť na prepojenie',
  'fabric.editor.inlineOverlay': 'Configure',
  'fabric.editor.inlineTitle': 'Vnorené',
  'fabric.editor.inputQueryAssistiveTxt':
    'Keď sú k dispozícii výsledky automatického dokončovania, použite šípky nahor a nadol na preskúmanie a kláves Enter na výber. Používatelia dotykových zariadení môžu skúmať dotykom alebo potiahnutím prstom.',
  'fabric.editor.insertColumn': 'Vložiť stĺpec vpravo',
  'fabric.editor.insertColumnDrag': 'Vložiť stĺpec',
  'fabric.editor.insertMenu': 'Vložiť prvky',
  'fabric.editor.insertRightRail.close': 'Zatvoriť',
  'fabric.editor.insertRightRail.title': 'Vložiť',
  'fabric.editor.insertRow': 'Vložiť riadok nižšie',
  'fabric.editor.insertRowDrag': 'Vložiť riadok',
  'fabric.editor.insertTableColumn': 'Vložiť stĺpec tabuľky',
  'fabric.editor.insertTableRow': 'Vložiť riadok tabuľky',
  'fabric.editor.invalidDateError': 'Zadajte platný dátum',
  'fabric.editor.invalidLink': 'Zadajte platné prepojenie.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Pozvať tímového spolupracovníka do aplikácie {productName}} trusted {Pozvať tímového spolupracovníka do aplikácie {productName}} other {Pridať tímového spolupracovníka do aplikácie {productName}}}',
  'fabric.editor.italic': 'Kurzíva',
  'fabric.editor.keyboardShortcuts': 'Klávesové skratky',
  'fabric.editor.layout.columnOption':
    '{count, plural, one {{count} stĺpec} few {{count} stĺpce} many {{count} stĺpcov} other {{count} stĺpcov}}',
  'fabric.editor.layout.controls.placeholder': '/ pre vloženie',
  'fabric.editor.layout.placeholder': 'Pridajte obsah',
  'fabric.editor.layout.resizeLayout': 'Zmeniť veľkosť rozloženia',
  'fabric.editor.layoutFixedWidth': 'Späť do centra',
  'fabric.editor.layoutFullWidth': 'Celá šírka',
  'fabric.editor.layoutStateFixedWidth': 'Vystredené',
  'fabric.editor.layoutStateFullWidth': 'Plná šírka',
  'fabric.editor.layoutStateWide': 'Široké',
  'fabric.editor.layoutWide': 'Rozšíriť',
  'fabric.editor.leftSidebar': 'Rozloženie ľavého bočného panela',
  'fabric.editor.link': 'Prepojenie',
  'fabric.editor.link.description': 'Vložiť prepojenie',
  'fabric.editor.linkAddress': 'Adresa prepojenia',
  'fabric.editor.linkPlaceholder': 'Vložiť prepojenie',
  'fabric.editor.lists': 'Zoznamy',
  'fabric.editor.listsFormat': 'Formátovanie zoznamu',
  'fabric.editor.lockColumns': 'Pevné šírky stĺpcov',
  'fabric.editor.longEmptyNodePlaceholderText': 'Zadaním / môžete vložiť prvky',
  'fabric.editor.markdown': 'Vyznačenie',
  'fabric.editor.matchCase': 'Citlivosť na veľké a malé písmená',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Šírka média sa zmenšila na {newMediaWidth,number} pixel.} few {Šírka média sa zmenšila na {newMediaWidth,number} pixely.} many {Šírka média sa zmenšila na {newMediaWidth,number} pixelov.} other {Šírka média sa zmenšila na {newMediaWidth,number} pixelov.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Šírka média sa zväčšila na {newMediaWidth,number} pixel.} few {Šírka média sa zväčšila na {newMediaWidth,number} pixely.} many {Šírka média sa zväčšila na {newMediaWidth,number} pixelov.} other {Šírka média sa zväčšila na {newMediaWidth,number} pixelov.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Médium bolo zmenšené na minimálnu veľkosť',
  'fabric.editor.media.insert.cancel': 'Zrušiť',
  'fabric.editor.media.insert.fileTabTitle': 'Súbor',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Toto prepojenie na obrázok bohužiaľ nie je možné pridať. Stiahnite obrázok a potom ho presuňte na stránku.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Tento obrázok nemusí byť viditeľný pre ostatných kvôli obmedzenému prístupu ku zdroju. Namiesto toho zvážte nahratie súboru.',
  'fabric.editor.media.insert.insert': 'Vložiť',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Neplatné prepojenie',
  'fabric.editor.media.insert.linkTabTitle': 'Prepojenie',
  'fabric.editor.media.insert.loadPreview': 'Načítať ukážku',
  'fabric.editor.media.insert.localFileErrorMessage': 'Tento súbor sa nedá nahrať.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Chyba pri nahrávaní súboru. Skontrolujte cestu alebo pripojenie k sieti.',
  'fabric.editor.media.insert.mediaAlt': 'Ukážka nahraného súboru s obrázkom alebo videom',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Nástroj na výber média',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Vložte prepojenie na položku, ktorú chcete nahrať',
  'fabric.editor.media.insert.upload': 'Nahrať',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Médium bolo zväčšené na maximálnu veľkosť',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Zmeniť veľkosť',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Zatvoriť',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'zadaná výška',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Výška',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Max. šírka {maxWidth} pixelov',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Šírka',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Max. šírka {maxWidth} pixelov',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Konvertovať na pixely',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip':
    'Prechod z percentuálneho vyjadrenia na pevnú veľkosť v pixeloch',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Odoslať',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Overenie šírky zlyhalo',
  'fabric.editor.mediaAddLink': 'Pridať prepojenie',
  'fabric.editor.mediaFiles': 'Obrázok, video alebo súbor',
  'fabric.editor.mediaFiles.description': 'Pridajte obrázky a ďalšie súbory na stránku',
  'fabric.editor.mediaGroupDeleteLabel': 'Odstrániť',
  'fabric.editor.media_change_mediainline_caption_warn': 'Vnorené (titulok bude odstránený)',
  'fabric.editor.media_change_mediainline_default': 'Vnorené',
  'fabric.editor.media_change_mediasingle': 'Pôvodná veľkosť',
  'fabric.editor.mention': 'Zmienka',
  'fabric.editor.mention.description': 'Zmieňte niekoho a pošlite mu oznámenie',
  'fabric.editor.mentionNode.label': 'Označený používateľ',
  'fabric.editor.mentionsAddLabel': 'pridať ikonu',
  'fabric.editor.mentionsIconLabel': 'Zmienka',
  'fabric.editor.mergeCells': 'Zlúčiť bunky',
  'fabric.editor.moreFormatting': 'Ďalšie formátovanie',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Presunúť stĺpec doľava} few {Presunúť stĺpce doľava} many {Presunúť stĺpce doľava} other {Presunúť stĺpce doľava}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Presunúť stĺpec doprava} few {Presunúť stĺpce doprava} many {Presunúť stĺpce doprava} other {Presunúť stĺpce doprava}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Presunúť riadok nadol} few {Presunúť riadky nadol} many {Presunúť riadky nadol} other {Presunúť riadky nadol}}',
  'fabric.editor.moveRowUp':
    '{0, plural, one {Presunúť riadok nahor} few {Presunúť riadky nahor} many {Presunúť riadky nahor} other {Presunúť riadky nahor}}',
  'fabric.editor.navigate.toolbar.askAI': 'Opýtať sa AI',
  'fabric.editor.navigate.toolbar.editor': 'Prejsť na panel s nástrojmi editora',
  'fabric.editor.navigate.toolbar.floating': 'Prejsť na plávajúci panel s nástrojmi',
  'fabric.editor.noResultsFound': 'Žiadne výsledky',
  'fabric.editor.noSearchResults': 'Žiadne výsledky vyhľadávania',
  'fabric.editor.normal': 'Normálny text',
  'fabric.editor.note': 'Poznámka',
  'fabric.editor.notePanel': 'Panel poznámok',
  'fabric.editor.notePanel.description': 'Pridať poznámku do farebného panela',
  'fabric.editor.numberedColumn': 'Číslovaný stĺpec',
  'fabric.editor.off': '{formattingType} vypnuté',
  'fabric.editor.offlineErrorFallbackDescription': 'Skúste znova načítať stránku.',
  'fabric.editor.offlineErrorFallbackHeading': 'Niečo sa pokazilo.',
  'fabric.editor.on': '{formattingType} zapnuté',
  'fabric.editor.openCellOptions': 'Otvoriť možnosti bunky',
  'fabric.editor.openLink': 'Otvoriť prepojenie na novej karte',
  'fabric.editor.orderedList': 'Očíslovaný zoznam',
  'fabric.editor.orderedList.description': 'Vytvoriť zoradený zoznam',
  'fabric.editor.other': 'Iné...',
  'fabric.editor.outdent': 'Odsek',
  'fabric.editor.overflowMenuViewMore': 'Zobraziť ďalšie',
  'fabric.editor.pageActionsLabel': 'Činnosti so stránkou',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Farba pozadia',
  'fabric.editor.panel.custom': 'Vlastné',
  'fabric.editor.panel.emoji': 'Pridať emodži',
  'fabric.editor.panel.panelsGroup': 'Typy panelov',
  'fabric.editor.pasteOptions': 'Možnosti vloženia',
  'fabric.editor.pastePlainText': 'Vložiť obyčajný text',
  'fabric.editor.placeholderAltText': 'Popísať obrázok alternatívnym textom',
  'fabric.editor.placeholderText': 'Zástupný text',
  'fabric.editor.placeholderText.description': 'Vložte zástupný text na stránku',
  'fabric.editor.placeholderTextPlaceholder': 'Pridať zástupný text',
  'fabric.editor.plainText': 'Použiť obyčajný text',
  'fabric.editor.preferencesLink': 'Predvoľby prepojení',
  'fabric.editor.quickInsert': 'Rýchlo vložiť',
  'fabric.editor.recordLoomShortTitle': 'Zaznamenať',
  'fabric.editor.recordVideo': 'Nahrať video Loom',
  'fabric.editor.recordVideo.description': 'Nahrajte svoju obrazovku a podeľte sa o svoje nápady',
  'fabric.editor.redo': 'Vrátiť naspäť',
  'fabric.editor.remove': 'Odstrániť',
  'fabric.editor.removeColumns':
    '{0, plural, one {Odstrániť stĺpec} few {Odstrániť stĺpce} many {Odstrániť stĺpce} other {Odstrániť stĺpce}}',
  'fabric.editor.removeEmoji': 'Odstrániť emodži',
  'fabric.editor.removeImageBorder': 'Odstrániť ohraničenie',
  'fabric.editor.removeRows':
    '{0, plural, one {Odstrániť riadok} few {Odstrániť riadky} many {Odstrániť riadky} other {Odstrániť riadky}}',
  'fabric.editor.replace': 'Nahradiť',
  'fabric.editor.replaceAll': 'Nahradiť všetko',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {Bola nahradená {numberOfMatches,number} zhoda.} few {Boli nahradené {numberOfMatches,number} zhody.} many {Bolo nahradených {numberOfMatches,number} zhôd.} other {Bolo nahradených {numberOfMatches,number} zhôd.}}',
  'fabric.editor.replaceWith': 'Nahradiť textom',
  'fabric.editor.requestToEdit': 'Požiadať o prístup k úpravám',
  'fabric.editor.requestToEditDescription': 'Keď požiadate o prístup, vlastník stránky dostane upozornenie.',
  'fabric.editor.requestToEditDismiss': 'Zrušiť',
  'fabric.editor.resizeHandle': 'Rukoväť na zmenu veľkosti',
  'fabric.editor.resultsCount': '{selectedMatchPosition} z {totalResultsCount}',
  'fabric.editor.richText': 'Použiť formátovaný text',
  'fabric.editor.rightSidebar': 'Rozloženie pravého panela',
  'fabric.editor.rowControl': 'Zvýrazniť riadok',
  'fabric.editor.rowDragHandle': 'Možnosti riadka',
  'fabric.editor.rowMovedDown': 'Riadok bol presunutý nadol na pozíciu {index} z {total}.',
  'fabric.editor.rowMovedUp': 'Riadok bol presunutý nahor na pozíciu {index} z {total}.',
  'fabric.editor.rowSelected': 'Riadok {index} z {total} vybraných',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Bol vložený riadok.} few {Boli vložené {count} riadky.} many {Bolo vložených {count} riadkov.} other {Bolo vložených {count} riadkov.}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Riadok bol odstránený.} few {Boli odstránené {count} riadky.} many {Bolo odstránených {count} riadkov.} other {Bolo odstránených {count} riadkov.}}',
  'fabric.editor.saveButton': 'Uložiť',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {K dispozícii je {itemsLength,number} výsledok vyhľadávania. Pomocou klávesov so šípkami nahor a nadol sa môžete pohybovať medzi možnosťami. Stlačením tlačidla Enter vyberte možnosť.} few {K dispozícii sú {itemsLength,number} výsledky vyhľadávania. Pomocou klávesov so šípkami nahor a nadol sa môžete pohybovať medzi možnosťami. Stlačením tlačidla Enter vyberte možnosť.} many {K dispozícii je {itemsLength,number} výsledkov vyhľadávania. Pomocou klávesov so šípkami nahor a nadol sa môžete pohybovať medzi možnosťami. Stlačením tlačidla Enter vyberte možnosť.} other {K dispozícii je {itemsLength,number} výsledkov vyhľadávania. Pomocou klávesov so šípkami nahor a nadol sa môžete pohybovať medzi možnosťami. Stlačením tlačidla Enter vyberte možnosť.}}',
  'fabric.editor.selectColumnResize': 'Vybrať zmenu veľkosti stĺpca',
  'fabric.editor.selectLanguage': 'Vybrať jazyk',
  'fabric.editor.selectTableColumn': 'Vybrať stĺpec tabuľky',
  'fabric.editor.selectTableRow': 'Vybrať riadok tabuľky',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Vybrať aplikáciu',
  'fabric.editor.settingsLinks': 'Prejsť na predvoľby prepojení',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ pre vloženie',
  'fabric.editor.shortcut': 'Textová skratka',
  'fabric.editor.single': 'Rozloženie s jedným stĺpcom',
  'fabric.editor.singleColumns': 'Rozloženie s 1 stĺpcom',
  'fabric.editor.sortColumnASC': 'Sort column A → Z',
  'fabric.editor.sortColumnDESC': 'Sort column Z → A',
  'fabric.editor.sortColumnDecreasing': 'Zoradiť zostupne',
  'fabric.editor.sortColumnIncreasing': 'Zoradiť vzostupne',
  'fabric.editor.splitCell': 'Rozdeliť bunky',
  'fabric.editor.status': 'Stav',
  'fabric.editor.status.description': 'Pridať vlastný štítok stavu',
  'fabric.editor.statusPlaceholder': 'Nastaviť stav',
  'fabric.editor.story': 'Príbeh',
  'fabric.editor.strike': 'Preškrtnúť',
  'fabric.editor.subTask': 'Podúloha',
  'fabric.editor.subscript': 'Dolný index',
  'fabric.editor.subscript.off.superscript.on': 'Dolný index vypnutý, horný index zapnutý',
  'fabric.editor.success': 'Úspech',
  'fabric.editor.successPanel': 'Panel úspechov',
  'fabric.editor.successPanel.description': 'Pridať tipy do farebného panela',
  'fabric.editor.superscript': 'Horný index',
  'fabric.editor.superscript.off.subscript.on': 'Horný index vypnutý, dolný index zapnutý',
  'fabric.editor.supportAltText':
    'Alternatívny text je užitočný pre ľudí so zrakovým postihnutím používajúcich čítačky obrazovky.',
  'fabric.editor.table': 'Tabuľka',
  'fabric.editor.table.description': 'Vložiť tabuľku',
  'fabric.editor.tableAlignmentOptions': 'Možnosti zarovnania',
  'fabric.editor.tableFullWidthLabel': 'Celá šírka',
  'fabric.editor.tableHeader.sorting.asc': 'Je použité vzostupné zoradenie',
  'fabric.editor.tableHeader.sorting.default': 'Zoradiť stĺpec',
  'fabric.editor.tableHeader.sorting.desc': 'Je použité zostupné zoradenie',
  'fabric.editor.tableHeader.sorting.invalid': 'Nie je možné zoradiť tabuľku so zlúčenými bunkami.',
  'fabric.editor.tableHeader.sorting.no': 'Stĺpec nie je zoradený',
  'fabric.editor.tableOptions': 'Možnosti tabuľky',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Šírka tabuľky sa zmenšila na {newWidth,number} pixel.} few {Šírka tabuľky sa zmenšila na {newWidth,number} pixely.} many {Šírka tabuľky sa zmenšila na {newWidth,number} pixelov.} other {Šírka tabuľky sa zmenšila na {newWidth,number} pixelov.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Šírka tabuľky sa zväčšila na {newWidth,number} pixel.} few {Šírka tabuľky sa zväčšila na {newWidth,number} pixely.} many {Šírka tabuľky sa zväčšila na {newWidth,number} pixelov.} other {Šírka tabuľky sa zväčšila na {newWidth,number} pixelov.}}',
  'fabric.editor.tableSelector': 'Veľkosť tabuľky',
  'fabric.editor.tableSelector.description': 'Pridať tabuľku pomocou vyskakovacieho okna na výber vlastnej veľkosti',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} x {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Nástroj na výber veľkosti tabuľky',
  'fabric.editor.tables.adjustColumn': 'Upraviť stĺpec',
  'fabric.editor.tables.columnResizeLast': 'Veľkosť stĺpca môžete zmeniť iba z ľavej strany.',
  'fabric.editor.tables.columnResizeOverflow':
    'Veľkosť tohto stĺpca je možné meniť len vtedy, keď má tabuľka posuvník.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Šírka stĺpca bola zmenená na {width} pixel.} few {Šírka stĺpca bola zmenená na {width} pixely.} many {Šírka stĺpca bola zmenená na {width} pixela.} other {Šírka stĺpca bola zmenená na {width} pixelov.}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Odstránením položky {nodeName} sa od nej odpojí všetko, čo je k nej pripojené.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Odstrániť',
  'fabric.editor.tables.resizeStop': 'Zmena veľkosti zastavená',
  'fabric.editor.tables.resizeTable': 'Zmeniť veľkosť tabuľky',
  'fabric.editor.tables.startedColumnResize': 'Zmena veľkosti začatá',
  'fabric.editor.task': 'Úloha',
  'fabric.editor.taskPlaceholder': 'Napíšte svoju činnosť. Pomocou "@" ju niekomu priraďte.',
  'fabric.editor.text.formatting.off': 'Formátovanie textu vypnuté',
  'fabric.editor.textColor': 'Farba textu: {selectedColorName}',
  'fabric.editor.textColorTooltip': 'Farba textu',
  'fabric.editor.textFormat': 'Formátovať text',
  'fabric.editor.textFormatting': 'Formátovanie textu',
  'fabric.editor.textStyles': 'Štýly textu: {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Štýly textu',
  'fabric.editor.threeColumns': 'Rozloženie s 3 stĺpcami',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Rozloženie s tromi stĺpcami a bočným panelom vľavo',
  'fabric.editor.threeColumnsWithRightSidebars': 'Rozloženie s tromi stĺpcami a bočným panelom vpravo',
  'fabric.editor.threeColumnsWithSidebars': 'Rozloženie s tromi stĺpcami a bočnými panelmi',
  'fabric.editor.time.ago': 'dozadu',
  'fabric.editor.time.updated': 'Aktualizované',
  'fabric.editor.time.viewed': 'Zobrazené',
  'fabric.editor.toolbarAppears': 'Zobrazenie panela s nástrojmi',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Pridať obrázok, video alebo súbor',
  'fabric.editor.toolbarPositionFixedAtTop': 'Upevnený v hornej časti',
  'fabric.editor.toolbarPositionInline': 'Vnorený v texte',
  'fabric.editor.tooltip.blockPanel': 'panel',
  'fabric.editor.tooltip.bulletList': 'zoznam',
  'fabric.editor.tooltip.decisionList': 'zoznam rozhodnutí',
  'fabric.editor.tooltip.defaultBlockNode': 'blokujúci uzol',
  'fabric.editor.tooltip.nestedExpand': 'vnorené rozšírenie',
  'fabric.editor.tooltip.taskList': 'položka činnosti',
  'fabric.editor.turnInto': 'Premeniť na',
  'fabric.editor.twoColumns': 'Rozloženie s 2 stĺpcami',
  'fabric.editor.typeAhead.popupLabel': 'Výsledky našepkávača',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Začnite písať, aby ste vyhľadali alebo vyfiltrovali možnosti skratiek',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Vyhľadať',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Skratky pre vložené položky a formátovanie',
  'fabric.editor.typeahead.emojiInputLabel': 'Začnite písať, aby ste vyhľadali alebo vyfiltrovali možnosti pre emodži',
  'fabric.editor.typeahead.emojiListItemLabel': 'Emodži {name}, textová skratka {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Skratky pre emodži',
  'fabric.editor.typeahead.mentionInputLabel': 'Začnite písať, aby ste vyhľadali používateľov, ktorých chcete označiť',
  'fabric.editor.typeahead.mentionPopupLabel': 'Používatelia, ktorých môžete označiť',
  'fabric.editor.typeahead.metionListItemLabel': 'Používateľ {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Tento obsah sa nedá načítať',
  'fabric.editor.unableToOpenLink': 'Toto prepojenie sa nedá otvoriť',
  'fabric.editor.underline': 'Podčiarknuť',
  'fabric.editor.undo': 'Späť',
  'fabric.editor.unknown.label': 'Neznámy',
  'fabric.editor.unlink': 'Zrušiť prepojenie',
  'fabric.editor.unorderedList': 'Zoznam s odrážkami',
  'fabric.editor.unorderedList.description': 'Vytvoriť nezoradený zoznam',
  'fabric.editor.unsupportedBlockContent': 'Tento editor nepodporuje zobrazenie tohto obsahu',
  'fabric.editor.unsupportedContentTooltip': 'Obsah nie je v tomto editore dostupný, pri úprave a uložení sa zachová',
  'fabric.editor.unsupportedInlineContent': 'Nepodporovaný obsah',
  'fabric.editor.upDown':
    'Pri použití klávesov so šípkami nahor a nadol v nasledujúcom vstupnom poli sa zaktualizuje dátum nižšie.',
  'fabric.editor.url': 'Zobrazovaná URL',
  'fabric.editor.urlDescription': 'Zobraziť prepojenie ako adresu URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Použiť vyznačenie',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Zobraziť a pridať komentáre',
  'fabric.editor.viewCommentOnMedia': 'Zobraziť komentáre',
  'fabric.editor.viewMore': 'Zobraziť viac',
  'fabric.editor.visit': 'Otvoriť prepojenie v novom okne',
  'fabric.editor.warning': 'Varovanie',
  'fabric.editor.warningPanel': 'Panel výstrah',
  'fabric.editor.warningPanel.description': 'Pridať upozornenie do farebného panela',
  'fabric.editor.wrapLeft': 'Zbaliť vľavo',
  'fabric.editor.wrapRight': 'Zbaliť vpravo',
  'fabric.emoji.label': 'Emodži',
  'fabric.theme.blue': 'Modrá',
  'fabric.theme.bold-blue': 'Sýtomodrá',
  'fabric.theme.bold-gray': 'Sýta sivá',
  'fabric.theme.bold-green': 'Sýtozelená',
  'fabric.theme.bold-magenta': 'Sýta purpurová',
  'fabric.theme.bold-orange': 'Sýtooranžová',
  'fabric.theme.bold-purple': 'Sýtofialová',
  'fabric.theme.bold-red': 'Sýtočervená',
  'fabric.theme.bold-teal': 'Sýtomodrozelená',
  'fabric.theme.bold-yellow': 'Sýta žltá',
  'fabric.theme.bolder-blue': 'Sýtejšia modrá',
  'fabric.theme.bolder-gray': 'Sýtejšia sivá',
  'fabric.theme.bolder-green': 'Sýtejšia zelená',
  'fabric.theme.bolder-magenta': 'Sýtejšia purpurová',
  'fabric.theme.bolder-orange': 'Sýtejšia oranžová',
  'fabric.theme.bolder-purple': 'Sýtejšia fialová',
  'fabric.theme.bolder-red': 'Sýtejšia červená',
  'fabric.theme.bolder-teal': 'Sýtejšia modrozelená',
  'fabric.theme.bolder-yellow': 'Sýtejšia žltá',
  'fabric.theme.dark-blue': 'Tmavomodrá',
  'fabric.theme.dark-gray': 'Tmavosivá',
  'fabric.theme.dark-green': 'Tmavozelená',
  'fabric.theme.dark-purple': 'Tmavofialová',
  'fabric.theme.dark-red': 'Tmavočervená',
  'fabric.theme.dark-teal': 'Tmavomodrozelená',
  'fabric.theme.dark-yellow': 'Tmavožltá',
  'fabric.theme.default': 'Predvolené',
  'fabric.theme.gray': 'Sivá',
  'fabric.theme.green': 'Zelená',
  'fabric.theme.light-blue': 'Svetlomodrá',
  'fabric.theme.light-gray': 'Svetlosivá',
  'fabric.theme.light-green': 'Svetlozelená',
  'fabric.theme.light-purple': 'Svetlofialová',
  'fabric.theme.light-red': 'Svetločervená',
  'fabric.theme.light-teal': 'Svetlomodrozelená',
  'fabric.theme.light-yellow': 'Svetložltá',
  'fabric.theme.lime': 'Limetková',
  'fabric.theme.magenta': 'Purpurová',
  'fabric.theme.no-color': 'Bez zvýraznenia',
  'fabric.theme.orange': 'Oranžová',
  'fabric.theme.purple': 'Fialová',
  'fabric.theme.red': 'Červená',
  'fabric.theme.subtle-blue': 'Jemná modrá',
  'fabric.theme.subtle-gray': 'Jemná šedá',
  'fabric.theme.subtle-green': 'Jemná zelená',
  'fabric.theme.subtle-magenta': 'Jemná purpurová',
  'fabric.theme.subtle-orange': 'Jemná oranžová',
  'fabric.theme.subtle-purple': 'Jemná fialová',
  'fabric.theme.subtle-red': 'Jemná červená',
  'fabric.theme.subtle-teal': 'Jemná modrozelená',
  'fabric.theme.subtle-yellow': 'Jemná žltá',
  'fabric.theme.teal': 'Modrozelená',
  'fabric.theme.white': 'Biela',
  'fabric.theme.yellow': 'Žltá',
  'fabrid.editor.rowNumbers': 'Čísla riadkov',
  'rovo.agents.dropdown.title': 'Agenti',
  'rovo.agents.dropdown.viewAgents.label': 'Zobraziť všetkých agentov',
};
